/**
 * Codes the server sets when it refuses an App Container request. They reach
 * the Studio as GraphQL error extension or as the name of a user friendly
 * error, depending on the transport.
 */
import { UserFriendlyError } from '@affine/error';

/**
 * The fields the server hands over with a refusal of this code to localize
 * it; null for any other error.
 */
export function appBaseErrorData(
  error: unknown,
  code: string
): Record<string, unknown> | null {
  if (!hasAppBaseErrorCode(error, code)) return null;
  const graphQLErrors = (
    error as {
      graphQLErrors?: Array<{
        extensions?: { code?: unknown; data?: unknown };
      }>;
    }
  )?.graphQLErrors;
  const data =
    graphQLErrors?.find(graphQLError => graphQLError.extensions?.code === code)
      ?.extensions?.data ?? UserFriendlyError.fromAny(error).data;
  return data && typeof data === 'object'
    ? (data as Record<string, unknown>)
    : {};
}

export function hasAppBaseErrorCode(error: unknown, code: string): boolean {
  const graphQLErrors = (
    error as { graphQLErrors?: Array<{ extensions?: { code?: unknown } }> }
  )?.graphQLErrors;
  if (
    graphQLErrors?.some(graphQLError => graphQLError.extensions?.code === code)
  ) {
    return true;
  }
  const name: string = UserFriendlyError.fromAny(error).name;
  return name === code;
}
